module.exports = __webpack_public_path__ + "static/index-3b0a06b99df4523fddf87317f7e12b25.png";